<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text>
          <template>
            <v-toolbar color="primary" light>
              <v-toolbar-title class="white--text">Settings</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down">
                <v-btn color="white" dark flat @click="save">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </template></v-card-text
        ></v-card
      ></v-container
    >
    <v-container>
      <v-form v-model="valid">
        <v-layout row wrap>
          <v-flex xs3> Application Name </v-flex>
          <v-flex xs9>
            <v-text-field
              placeholder="App Name"
              v-model="config.app_name"
              :rules="rules.required"
            ></v-text-field>
          </v-flex>
          <v-flex xs3> Delivery Threshold </v-flex>
          <v-flex xs9>
            <v-text-field
              placeholder="Delivery Threshold"
              v-model.number="config.delivery_threshold"
            ></v-text-field>
          </v-flex>

          <v-flex xs3 v-if="config.type === 'grocery'">
            Delivery Timeslots
          </v-flex>
          <v-flex v-if="config.type === 'grocery'" xs9>
            <v-combobox
              multiple
              v-model="config.timeslots"
              label="Timeslots"
              append-icon
              chips
              deletable-chips
              class="tag-input"
              :search-input.sync="timeslot"
              @keyup.tab="updateSlots"
              @paste="updateSlots"
            >
            </v-combobox>
          </v-flex>
          <v-flex xs3> Minimum Order Amount </v-flex>
          <v-flex xs9>
            <v-text-field
              placeholder="Minimum Order Amount"
              v-model.number="config.minimum_order_amount"
            ></v-text-field>
          </v-flex>
          <v-flex xs3> Payment Methods </v-flex>
          <v-flex xs9>
            <v-switch
              v-model="config.cod"
              label="COD"
              color="success"
            ></v-switch>
            <v-switch
              v-model="config.online"
              label="Online"
              color="success"
            ></v-switch>
          </v-flex>

          <template v-if="config.type == 'grocery'">
            <v-flex xs3> Same Day Delivery </v-flex>
            <v-flex xs9>
              <v-switch
                v-model="config.same_day_delivery"
                color="success"
              ></v-switch>
            </v-flex>
          </template>
          <v-flex xs3 v-if="config.type === 'grocery'">
            Availble Locations
          </v-flex>
          <v-flex v-if="config.type === 'grocery'" xs9>
            <v-layout row>
              <template v-for="(v, index) in config.cities">
                <v-flex :key="index" xs2>
                  <v-text-field
                    label="City*"
                    :rules="rules.required"
                    required
                    v-model="v.name"
                  ></v-text-field>
                </v-flex>
                <v-flex :key="index + 'a'" xs4 mx-1>
                  <v-combobox
                    multiple
                    v-model="v.areas"
                    label="Areas"
                    item-text="name"
                    item-value="name"
                    append-icon
                    chips
                    small-chips
                    dense
                    deletable-chips
                    return-object
                    class="tag-input"
                    @input="createArea(v)"
                  >
                  </v-combobox>
                </v-flex>
                <v-flex xs5 mx-1 :key="index + 'b'" v-if="v.areas.length">
                  <v-select
                    :items="v.areas.filter(a => a.name).map(a => a.name)"
                    v-model="area"
                    label="Select Area"
                  >
                  </v-select>
                  <v-combobox
                    multiple
                    v-if="v.areas.find(a => a.name === area)"
                    v-model="v.areas.find(a => a.name === area).apartments"
                    :label="'Apartments in ' + area"
                    append-icon
                    item-text="name"
                    item-value="name"
                    @input="
                      createApartment(
                        v.areas.find(a => a.name === area).apartments,
                      )
                    "
                    chips
                    small-chips
                    dense
                    deletable-chips
                    return-object
                    class="tag-input"
                  >
                  </v-combobox>
                </v-flex>
                <v-flex :key="index + 'c'" xs1>
                  <v-btn
                    round
                    fab
                    small
                    color="red"
                    @click="removeLocation(index)"
                    dark
                    ><v-icon>mdi-minus</v-icon></v-btn
                  >
                </v-flex>
              </template>
            </v-layout>
            <v-layout row>
              <v-flex xs12 d-flex align-content-space-between>
                <v-btn
                  dense
                  small
                  outline
                  style="width: 30px"
                  color="primary"
                  @click="addLocation()"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            Address
          </v-flex>
          <v-flex xs9>
            <v-textarea
              name="input-7-1"
              label="Business Address"
              v-model="config.address"
            ></v-textarea>
          </v-flex>
          <v-flex xs3> Contact </v-flex>
          <v-flex xs9>
            <v-text-field
              placeholder="Contact"
              v-model="config.contact"
              :rules="rules.contact"
            ></v-text-field>
          </v-flex>
          <v-flex xs3> Instagram </v-flex>
          <v-flex xs9>
            <v-text-field
              placeholder="Instagram"
              v-model.number="config.instagram"
            ></v-text-field>
          </v-flex>
          <v-flex xs3> Facebook </v-flex>
          <v-flex xs9>
            <v-text-field
              placeholder="Facebook"
              v-model.number="config.facebook"
            ></v-text-field>
          </v-flex>
          <v-flex xs3> Mail </v-flex>
          <v-flex xs9>
            <v-text-field
              placeholder="Mail Address"
              v-model.number="config.mail"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>
<script type="text/javascript">
import api from '@/api';
export default {
  data() {
    return {
      valid: false,
      timeslot: '',
      area: '',
      config: {
        app_name: '',
        delivery_charge: 0,
        delivery_threshold: 0,
        minimum_order_amount: 0,
        contact: '',
        facebook: '',
        instagram: '',
        mail: '',
        linkedIn: '',
        timeslots: [],
        cod: 1,
        online: 0,
        same_day_delivery: false,
        weight_wise_delivery_charge: false,
        address: '',
        cities: [{ name: '', areas: [], apartments: {} }],
      },
      rules: {
        required: [v => /^(?!\s*$).+/.test(v) || 'Name is required'],
        contact: [v => /^[6-9]\d{9}$/.test(v) || !v || 'Invalid Phone Number'],
        number: [v => /^[0-9]+$/.test(v) || 'Only digits are allowed'],
      },
    };
  },
  created() {
    if (this.$store.state.vid)
      api
        .get('vendors/' + this.$store.state.vid)
        .then(r => {
          this.config = r.data;
        })
        .catch(async err => {
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
  },
  watch: {
    vid() {
      this.reload();
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
  },
  methods: {
    createApartment(a) {
      a = a.map(aptmt => {
        if (typeof aptmt === 'object') return aptmt;
        return { name: aptmt };
      });
    },

    reload() {
      let loader = this.$loading.show();
      api
        .get('vendors/' + this.$store.state.vid)
        .then(r => {
          this.config = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
    },
    save() {
      let loader = this.$loading.show();
      console.log(this.$store.state);
      api
        .put('vendors/' + this.$store.state.vid, this.config)
        .then(r => {
          this.config = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.save();
            }
          }
        });
    },
    updateSlots() {
      this.$nextTick(() => {
        this.config.timeslots.push(...this.timeslot.split(','));
        this.$nextTick(() => {
          this.timeslot = '';
        });
      });
    },
    addLocation() {
      this.config.cities.push({ name: '', areas: [], apartments: {} });
    },
    removeLocation(i) {
      this.config.cities.splice(i, 1);
    },
    createArea(v) {
      v.areas = v.areas.map(a => {
        if (typeof a === 'object') return a;
        return { name: a, apartments: [] };
      });
    },
  },
};
</script>
